import { render, staticRenderFns } from "./ProductAttributesMobile.vue?vue&type=template&id=828e113a&scoped=true&"
import script from "./ProductAttributesMobile.vue?vue&type=script&lang=js&"
export * from "./ProductAttributesMobile.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributesMobile.vue?vue&type=style&index=0&id=828e113a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828e113a",
  null
  
)

export default component.exports